import { Component, Inject, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { User } from '../lib/entities/User';
import { MainFacade } from '../pages/main.facade';
import { takeUntil} from 'rxjs/operators';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { Store } from '@ngrx/store';
import { MarketState } from '../lib/+state/market.reducer';
import { AuthService } from '../lib/services/auth.service';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  items:any[] = [
    {Name:"Explore", Icon:"../../../assets/img/nav-bar/compass.svg"},
    {Name:"Winners", Icon:"../../../assets/img/nav-bar/award.svg"},
    {Name:"Purchases", Icon:"../../../assets/img/nav-bar/shopping.svg"},
    {Name:"Wallet", Icon:"../../../assets/img/nav-bar/wallet.svg"},
    {Name:"Bids/Raffles", Icon:"../../../assets/img/nav-bar/auction.svg"},
    {Name:"Watchlist", Icon:"../../../assets/img/nav-bar/heart.svg"}
  ];

  public login$: Observable<any>|undefined;
  public error$: Observable<any>|undefined;
  public user$: Observable<any>|undefined;
  public nfts$: Observable<any>|undefined;
  public levels$: Observable<any>|undefined;
  public pass$: Observable<any>|undefined;
  public showProfileEdit$: Observable<any>|undefined;
  private destroy$ = new Subject();
  profileDropDown:boolean = false;
  showMobileMenu: boolean = false;
  walletSplit: any;
  wallet: any;
  walletFull: any;
  user:any;
  avatarSelect:any ='';
  urlmanual:any='';
  newUsername:any='';
  showNftsAvatar:boolean = false;
  page:any="";
  currentLevel:any="";

  constructor(@Inject(DOCUMENT) private doc: Document, private store: Store<MarketState>, private auth:AuthService, private mainfacade:MainFacade, private router:Router,private activeRoute:ActivatedRoute) { 


      router.events.subscribe((val) => {
        // see also 
        if(val instanceof NavigationEnd){
         
          this.page = val.url;
        }
    });
  
  }

  ngOnInit(): void {
    this.setObservables();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }

  setObservables() {
    this.login$ = this.mainfacade.login$;
    this.error$ = this.mainfacade.error$;
    this.nfts$ = this.mainfacade.nfts$
    this.user$ = this.mainfacade.user$;
    this.pass$ = this.mainfacade.pass$;
    this.showProfileEdit$ = this.mainfacade.showProfileEdit$;
    
    this.user$
    .pipe(takeUntil(this.destroy$))
    .subscribe((message)=>{ 

      if(message){
        this.user = message;
        this.wallet = this.user.Wallet.slice(0, 4) + "..." + this.user.Wallet.slice(41, 44);
        this.currentLevel = message.UserSkills.find((val)=>{
          return val.SkillName === 'Gang Level';
        })
      }


    });

    this.login$
    .pipe(takeUntil(this.destroy$))
    .subscribe((message)=>{ 
      if(message){
        this.walletFull = message
        this.walletSplit = message.slice(0, 4) + "..." + message.slice(41, 44);
      }

    });


    this.levels$ = this.mainfacade.levels$;
    
    this.mainfacade.getSeason();
  }


  editProfile() {
    //this.newUsername = this.user?.UserName;
    //this.showNftsAvatar = true;
  console.log('here')
  this.mainfacade.getMobileMenu(false);
    this.mainfacade.setShowProfileEdit(true);
  }

  closePop(){
    //this.mainfacade.getPopup('');
  }

  
  
  route(path){
    this.mainfacade.getMobileMenu(false);
    this.router.navigateByUrl(path)
  }
  
  shareprofile(){
    this.mainfacade.getMobileMenu(false);
    this.mainfacade.getShareprofile(true);
  }

  
  login(){
    this.mainfacade.login(null);
  }


  logout() {
    this.mainfacade.logout();
    
  }

}
